import { render, staticRenderFns } from "./panelBase.vue?vue&type=template&id=0b8ffe24"
import script from "./panelBase.vue?vue&type=script&lang=js"
export * from "./panelBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports